import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PopupLoaderComponent } from './popup-loader.component';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [PopupLoaderComponent],
  imports: [CommonModule,
    ProgressSpinnerModule,
    MatProgressBarModule,
  ],
  exports: [PopupLoaderComponent]
})
export class PopupLoaderModule { }
